import { render, staticRenderFns } from "./TagMap.vue?vue&type=template&id=2768a075&scoped=true&"
import script from "./TagMap.vue?vue&type=script&lang=js&"
export * from "./TagMap.vue?vue&type=script&lang=js&"
import style0 from "./TagMap.vue?vue&type=style&index=0&id=2768a075&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768a075",
  null
  
)

export default component.exports